import styled, { css } from 'styled-components';
import backgroundImage from '../../../../media/modal-feature-pro/studio-purchase-trial-modal-bg.png';

export const BackgroundWrapper = styled.div`
  ${({ theme }) => css`
    background-image: url(${backgroundImage});
    background-size: cover;
    background-position: center;
    border-radius: 8px;
    font-family: ${theme.v2.font.family.primary};

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      border-radius: 0;
    }
  `}
`;

export const Wrapper = styled.div`
  ${({ theme }) => css`
    background: ${theme.v2.colors.white.primary};
    border-radius: 16px;
    display: flex;
    flex-direction: column;
    margin: 32px;
    padding: 44px 24px 24px;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      margin: 24px;
      padding: 16px;
    }
  `};
`;

export const ModalContent = styled.div`
  ${({ theme }) => css`
    display: flex;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      flex-direction: column;
    }
  `};
`;

export const PurchaseActionsContainer = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    width: 50%;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      width: 100%;
    }
  `};
`;

export const ExplanationContainer = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    margin-left: auto;
    max-width: 360px;
    padding-left: 32px;
    position: relative;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      margin: 32px 0;
      padding-left: 0;
      max-width: 100%;
    }
  `};
`;

export const WrapperImage = styled.div`
  display: flex;
  overflow: hidden;

  img {
    max-width: 100%;
  }
`;

export const ModalTitle = styled.h3`
  ${({ theme }) => css`
    background: ${theme.v2.colors.gradient.secondary};
    font-size: ${theme.v2.font.sizes.md};
    font-weight: ${theme.v2.font.weights.bold};
    margin: 0;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  `}
`;

export const ModalDescription = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowPure};
    font-size: ${theme.v2.font.sizes.xxs};
    margin: 0;
    margin-top: 8px;

    strong {
      background: ${theme.v2.colors.gradient.secondary};
      font-weight: ${theme.v2.font.weights.medium};
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  `}
`;

export const RadioBlocksContainer = styled.div`
  ${({ theme }) => css`
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-top: 24px;
    width: fit-content;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      width: 100%;
    }
  `};
`;

export const ButtonsContainer = styled.div`
  display: flex;
  gap: 16px;
  justify-content: center;
  margin: 8px 0;
`;

export const BottomText = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowMedium};
    font-size: ${theme.v2.font.sizes.xxxs};
    margin: 0;
    text-align: center;
    max-width: 320px;

    a {
      font-size: ${theme.v2.font.sizes.xxxs};
    }

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      align-self: center;
    }
  `};
`;

export const ExplanationTitleContainer = styled.div`
  display: flex;
  gap: 8px;
  margin-bottom: 24px;
`;

export const ExplanationTitle = styled.h4`
  ${({ theme }) => css`
    background: ${theme.v2.colors.gradient.secondary};
    font-size: ${theme.v2.font.sizes.sm};
    font-weight: ${theme.v2.font.weights.bold};
    margin: 0;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  `};
`;

export const IconAiStarContainer = styled.div`
  height: 24px;
  margin-top: 4px;
  margin-left: 4px;
  width: 24px;
`;

export const TimelineBottomText = styled(BottomText)`
  align-self: start;
  margin-left: 48px;
  margin-top: 16px;
  text-align: start;
`;
